export default __webpack_public_path__ + "static/media/SS3Regular.otf.ebe851ff.woff";